export enum EWorkStatusEvent {
  MARKED_AS_IN_CORRECTION = "markedAsInCorrection",
  MARKED_AS_IN_PORTFOLIO = "markedAsInPortfolio",
  STATUS_CHANGED = "statusChanged",
  CHALLENGE_CLOSED = "challengeClosed",
  VERSION_MISMATCH = "versionMismatch",
}
